import { Team__Aliados } from "../teams/Aliados";
import { Team__Cerveceros_MAIN } from "../teams/Cerveceros_MAIN";
import { Team__Apaches } from "../teams/Apaches";
import { Team__MeanMachine } from "../teams/MeanMachine";
import { Team__Nogaleros } from "../teams/Nogaleros";
import { Team__BallBrothers } from "../teams/BallBrothers";
import { Team__UT } from "../teams/UT";
import { Team__XLobos } from "../teams/XLobos";

const Aliados = {
  team: Team__Aliados,
  playingPlayers: [],

  goals: 70,
  penaltyGoals: 0,
  isWinner: false,
};

const Apaches = {
  team: Team__Apaches,
  playingPlayers: [],

  goals: 32,
  penaltyGoals: 0,
  isWinner: false,
};

const Cerveceros = {
  team: Team__Cerveceros_MAIN,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const MeanMachine = {
  team: Team__MeanMachine,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Nogaleros = {
  team: Team__Nogaleros,
  playingPlayers: [],

  goals: 60,
  penaltyGoals: 0,
  isWinner: false,
};

const BallBrothers = {
  team: Team__BallBrothers,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const UTPaquime = {
  team: Team__UT,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const XLobos = {
  team: Team__XLobos,
  playingPlayers: [],

  goals: 59,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada4 = {
  jornadaPosition: 4,
  matches: [
    {
      team1: XLobos,
      team2: Aliados,

      isCompleted: true,
      isPlaying: true,
      day: "Jueves",
      date: "2025-07-31",
      time: "19:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Nogaleros,
      team2: Apaches,

      isCompleted: true,
      isPlaying: false,
      day: "Jueves",
      date: "2025-07-31",
      time: "20:00:00",
      location: "Centro Recreativo Lebaron",
    },
  ],
};
